module.exports = __webpack_public_path__ + "static/media/sidebar-gray.52074eb2.png";